import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Agency } from '../Model/InternalModel';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class InternalinvoiceService {
  private baseUrl: string;
  private InvociebaseUrl: string;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
    this.InvociebaseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }

  // Method to get the agency list
  getAgencyList() {
    return this.http.get(this.baseUrl + `/api/Agency`)
      .map(response => response as Agency[])
      .catch(handleError);
  }
  // Method to get the invoice grid
  GetInvoiceGrid(agencyID): Observable<any[]> {
    return this.http.get(this.InvociebaseUrl + `/api/Invoice/` + agencyID)
      .map(response => response)
      .catch(handleError);
  }
  // Get Order Grid data
  GetOrderGrid(agencyID): Observable<any[]> {
    return this.http.get(this.InvociebaseUrl + `/api/Order/` + agencyID)
      .map(response => response)
      .catch(handleError);
  }
  // Method to get order popup grid load
  GetOrderInvoiceGrid(orderInvoiceid, agencyID): Observable<any[]> {
    return this.http.get(this.InvociebaseUrl + `/api/OrderInvoice/` + agencyID + `/` + orderInvoiceid)
      .map(response => response)
      .catch(handleError);
  }
  
  getDownloadUrl(id: string): Observable<string> {
        //debugger;
        return this.http.get(this.InvociebaseUrl + `/api/aws/getDownloadUrl/` + id)
            .map(response => response)
            .catch(handleError);
    }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);
  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/internalinvoice/Service/internalinvoice.service.ts